module.exports = __webpack_public_path__ + "63b57392fcb03c577bf76d1c79e033c4.pdf";